export default "__VITE_ASSET__CCkZ31TP__"